import apiClient from "@/utils/httpClient";
import type { CommentDto, CreateCommentDto, CommentReferenceType } from "@blinkbooks/types";

export const getComments = (referenceType: CommentReferenceType, referenceId: string): Promise<CommentDto[]> =>
  apiClient.get<CommentDto[]>("/comments", { referenceType, referenceId });

export const createComment = (data: CreateCommentDto): Promise<CommentDto> =>
  apiClient.post<CommentDto>("/comments", data);

export const deleteComment = (id: string): Promise<void> =>
  apiClient.delete(`/comments/${id}`);
